
export const POD_LEAD_CAN_RELEASE_HOURS = 'podLeadReleaseHours';
export const REASSIGN_PODLEAD = 'REASSIGN_PODLEAD';
export const UNALLOCATION_REQUEST_APPROVAL = 'UNALLOCATION_REQUEST_APPROVAL'
export const WORK_PACKAGE_EXPANSION = 'WORK_PACKAGE_EXPANSION';
export const DISSOLVE_POD = 'DISSOLVE_POD';
export const CEC_STRUCTURE_TAB = 'CEC_STRUCTURE_TAB';
export const CEC_STRUCTURE_TAB_NON_ADMIN = 'CEC_STRUCTURE_TAB_NON_ADMIN';
export const CEC_PRACTITIONERS_TAB = 'CEC_PRACTITIONERS_TAB';
export const WITHDRAW_MULTIPLE_WORKPACKAGES = 'WITHDRAW_MULTIPLE_WORKPACKAGES';
export const WITHDRAW_INDIVIDUAL_WORKPACKAGES = 'WITHDRAW_INDIVIDUAL_WORKPACKAGES';
